import { UserTrophies } from '@app/home/trophies/trophies.model';
import { createStore, withProps, select } from '@ngneat/elf';

interface TrophiesState {
  items: UserTrophies[];
}

export function createInitialState(): TrophiesState {
  return { items: [] };
}

export const trophiesStore = createStore({ name: 'trophies' }, withProps<TrophiesState>(createInitialState()));

export const trophies$ = trophiesStore.pipe(select((state) => state.items));
